import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  width: 100%;
  height: calc(100% - 120px);
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;
export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0px;
  table-layout: fixed;
`;
export const Thead = styled.thead`
  background-color: ${ColorSF2.white};
`;
export const TheadTr = styled.tr`
  border-top: 1px solid ${ColorSF2.mediumGray};
  text-decoration: none;
  height: 27px;
  font-size: 12px;
  text-align: left;
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const Tbody = styled.tbody`
  width: 100%;
  background-color: ${ColorSF2.white};
`;
export const ScrolledBody = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
`;
export const TbodyTr = styled.tr`
  background-color: ${ColorSF2.white};
  border-bottom: 1px solid ${ColorSF2.mediumGray};
`;
export const DateCell = styled.td`
  width: 25%;
  font-size: 0.9rem;
  padding-left: 8px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
export const ParticipantsCell = styled.td`
  width: 60%;
  font-size: 0.9rem;
  padding: 11px 0;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const ButtonCell = styled.td`
  width: 15%;
`;
export const CenteredButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
export const ButtonImage = styled.img`
  margin-right: 4px;
  margin-bottom: 1px;
  height: 14px;
  display: flex;
  align-items: center;
`;
